import React from 'react';
import { useTranslation } from 'react-i18next';
import { NonReturnableIcon } from 'cat-ecommerce-alloy';

const NonReturnablePartIndicator = () => {
  const [t] = useTranslation();
  return (
    <p className="exclude-global d-flex align-items-center">
      <NonReturnableIcon className="me-1" height={20} width={20} />
      <span className="m-0 text-xs">{t('NON_RETURNABLE_PART')}</span>
    </p>
  );
};

export default NonReturnablePartIndicator;
